import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Appointment } from 'src/constants/types';
import { AppointmentCalendar } from 'src/modules/calendar/components/AppointmentCalendar';

type SelectAppointmentModalProps = {
  open: boolean;
  onClose: () => void;
  onSelect: (appointmentId: string) => void;
};

const SelectAppointmentModal: React.FC<SelectAppointmentModalProps> = ({
  open,
  onClose,
  onSelect,
}) => {
  if (!open) {
    return null;
  }

  const handleSelect = (appointment: Appointment) => {
    if (appointment.id) {
      onSelect(appointment.id);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        Choose Existing
        <IconButton aria-label="close" size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pb: 3, overflow: 'hidden' }}>
        <Box sx={{ height: '70vh', overflowY: 'auto' }}>
          <AppointmentCalendar selectMode onSelect={handleSelect} />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SelectAppointmentModal;
